export default __webpack_public_path__ + "static/media/port-logo-brasil.68e5ce7d.webp";